import { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';

const RTL_BASE_LANGUAGES = new Set(['ar', 'ur', 'he', 'fa']);

const isRtlLocale = (locale: string) =>
  RTL_BASE_LANGUAGES.has(locale.toLowerCase().split('-')[0]);

export const useLocaleDirection = () => {
  const { locale } = useIntl();

  // No cleanup: this hook mounts once at the app root alongside LeagueProvider
  // and owns the document dir/lang for the entire session.
  useEffect(() => {
    document.documentElement.setAttribute(
      'dir',
      isRtlLocale(locale) ? 'rtl' : 'ltr',
    );
    document.documentElement.setAttribute('lang', locale);
  }, [locale]);
};
